<template>
  <div class="section-report media">
    <Wrapper title="媒体和广告位统计">
      <template #header>
        <el-row>
          <el-col
            :span="14"
            :md="16"
          >
            <el-radio-group
              v-model="actTab"
              size="small"
              @change="onExTab"
            >
              <el-radio-button
                v-for="(v, i) in tabs"
                :key="i"
                :label="v.id"
              >
                {{
                  v.text
                }}
              </el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col
            :span="8"
            :md="8"
            style="text-align: right;"
          >
            <DatePicker @pick="pickDate" />
          </el-col>
        </el-row>
      </template>
      <template #content>
        <div class="chart-c">
          <div v-show="!hasChartMediaData">
            <Empty
              :border="false"
              tips="暂无数据"
            />
          </div>
          <div
            v-show="hasChartMediaData"
            ref="chartpie"
            class="chart-cb"
            style="height: 400px"
          />
        </div>
        <div class="chart-t">
          <div
            ref="chartbar"
            class="chart-tb"
            style="height: 400px"
          />
        </div>
      </template>
    </Wrapper>
  </div>
</template>

<script>
import echarts from 'echarts';
import accounting from 'accounting';
import { basePileBarOption } from '../echartConfig';
import roma from '../echartConfig/roma.json';
import { Empty } from '@/components';
import Request from '@/core/QuRequest';
import Wrapper from '../components/Wrapper';
import DatePicker from '../components/DatePicker';

const req = new Request();
// tabs
const Tabs = {
  '1': { id: 1, text: '全部', mt: '媒体占比', bt: '媒体消耗' },
  '2': { id: 2, text: '趣头条', mt: '趣头条占比', bt: '趣头条消耗' },
  '3': {
    id: 3,
    text: '联盟头部流量',
    mt: '联盟头部流量占比',
    bt: '联盟头部流量消耗',
  },
  '4': { id: 4, text: '米读小说', mt: '米读小说占比', bt: '米读小说消耗' },
  '5': { id: 5, text: '热点段子', mt: '热点段子占比', bt: '热点段子消耗' },
  '6': { id: 6, text: '趣键盘', mt: '趣键盘占比', bt: '趣键盘消耗' },
  '7': { id: 7, text: '联盟长尾', mt: '联盟长尾占比', bt: '联盟长尾消耗' },
  '8': { id: 8, text: '通投', mt: '通投占比', bt: '通投消耗' },
};

export default {
  name: 'SectionMedia',
  components: {
    Wrapper,
    DatePicker,
    Empty,
  },
  data() {
    return {
      // pick date
      date: '',
      timeDuration: [],

      // tab
      actTab: Tabs['1'].id,
      tabs: Object.values(Tabs),

      // pie
      pieOption: {},
      pileBarOption: {
        ...basePileBarOption,
      },
      pieFormatData: {},
      pileBarFormatData: {},
      hasChartMediaData: false,
      slice1: [],
      slice2: [],
      slice3: [],
      slice4: [],
      slice5: [],
      slice6: [],
      slice7: [],
      media: ['1', '2', '3', '4', '5', '6', '7'],
      posSlot: ['1', '2', '3', '4', '5', '7'],
      mediaMap: {
        '1': '米读',
        '2': '段子',
        '3': '趣键盘',
        '4': '趣头条',
        '5': '通投',
        '6': '联盟头部',
        '7': '联盟长尾',
      },
      posMap: {
        '1': '列表页信息流',
        '2': '详情页信息流',
        '3': '互动',
        '4': '开屏广告',
        '5': '横幅广告',
        '7': '激励广告',
      },
    };
  },

  created() {
    echarts.registerTheme('roma', roma);
    this._fethMediaData();
  },

  mounted() {
    // 初始化饼图和叠加图
    this.onExTab(1);
    window.addEventListener('resize', this.onPieReize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onPieReize);
  },

  methods: {
    // 选择日期
    pickDate({ duration = [] } = {}) {
      this.timeDuration = duration;
      this.date = duration[0] + ',' + duration[duration.length - 1];
      this._fethMediaData();
    },

    // 获取数据
    async _fethMediaData() {
      if (!this.date) return;
      try {
        const res = await req.send(req.Apis.sales.report.dataMedia, {
          date: this.date,
        });
        this.regroupPileBarData(res.data);
        this.regroupPieData(res.data);
        setTimeout(() => {
          this.onExTab(this.actTab);
        });
      } catch (err) {
        this.$message.error(`获取媒体数据失败：${err.message || '未知错误'}`);
      }
    },

    reInitEchart() {
      this.pieCharts = echarts.dispose(this.$refs['chartpie'], 'roma');
      this.pieCharts = echarts.init(this.$refs['chartpie'], 'roma');
      this.pileBarCharts = echarts.dispose(this.$refs['chartbar'], 'roma');
      this.pileBarCharts = echarts.init(this.$refs['chartbar'], 'roma');
    },

    onExTab(val) {
      const checkPieData = (dt) => !!((dt || {}).data || []).length;
      this.hasChartMediaData = checkPieData(this[`media${val}`]);

      this.$nextTick(() => {
        this.reInitEchart();

        this.pieFormatData = {
          ...this[`media${val}`],
          title: Tabs[val].mt || '',
        };
        this.setPie(this.pieFormatData);

        this.pileBarFormatData = {
          title: Tabs[val].bt || '',
          xAxisData: this.timeDuration,
          rawSeries: this[`slice${val}`],
        };
        this.setPileBar(this.pileBarFormatData);
      });
    },

    // 设置饼图
    setPie(op) {
      const updateTotal = (total = 0) => {
        let len = String(Math.floor(total)).length;
        len = len <= 6 ? 0 : len;
        return {
          text: '总消耗',
          subtext: `¥${accounting.formatNumber(total, 2)}`,
          textAlign: 'center',
          textStyle: {
            fontSize: 14,
            color: '#606266',
          },
          subtextStyle: {
            // 依据数字字符长度计算
            fontSize: Math.max(16, 30 * (1 - len / 30)),
            color: '#303133',
          },
          left: '50%',
          top: '44%',
        };
      };

      this.pieOption.title = {
        ...updateTotal(op.total),
      };

      this.pieOption.tooltip = {
        show: true,
        formatter: op.title,
        padding: 2,
        textStyle: {
          color: '#333',
          fontWeight: 'bold',
        },
        alwaysShowContent: true,
        backgroundColor: '#fff',
        position: [0, 0],
      };
      this.pieOption.series = [
        {
          type: 'pie',
          radius: ['48%', '65%'],
          label: {
            textStyle: {
              color: '#606266',
              fontSize: 14,
            },
          },
          data: op.data,
        },
      ];

      this.pieCharts.setOption(this.pieOption);
      this.pieCharts.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex: 0,
      });
    },

    // 设置叠加图
    setPileBar(op) {
      this.pileBarOption.title.text = op.title;
      this.pileBarOption.xAxis = {
        type: 'category',
        data: op.xAxisData,
      };
      this.pileBarOption.yAxis.axisLabel = {
        formatter: '¥{value}',
      };
      this.pileBarOption.series = op.rawSeries.map((item, index) => {
        item.type = 'bar';
        item.barWidth = '50%';
        item.stack = '总量';
        // item.label = PileLabel;
        return item;
      });
      this.pileBarCharts.setOption(this.pileBarOption);
    },

    // 1 米读  2 段子  3 趣键盘  4 趣头条  5 通投  6 联盟头部  7 联盟长尾
    regroupPieData(data) {
      if (!data.chartMedia) {
        this.resetMedia();
        return;
      }
      let pie = data.chartMedia;

      this.media1 = this.getPieFormat(pie.total, 'total'); // 媒体
      this.media2 = this.getPieFormat(pie[4], 'pos'); // 广告位 趣头条
      this.media3 = this.getPieFormat(pie[6], 'pos'); // 广告位 联盟头部
      this.media4 = this.getPieFormat(pie[1], 'pos'); // 广告位 米读
      this.media5 = this.getPieFormat(pie[2], 'pos'); // 广告位 段子
      this.media6 = this.getPieFormat(pie[3], 'pos'); // 广告位 趣键盘
      this.media7 = this.getPieFormat(pie[7], 'pos'); // 广告位 联盟长尾
      this.media8 = this.getPieFormat(pie[5], 'pos'); // 广告位 通投
    },

    resetMedia() {
      this.media1 = {};
      this.media2 = {};
      this.media3 = {};
      this.media4 = {};
      this.media5 = {};
      this.media6 = {};
      this.media7 = {};
      this.media8 = {};
    },

    getPieFormat(source, type) {
      let formatted = {
        legendData: [],
        total: 0,
        data: [],
      };
      for (let i in source) {
        if (i === 'total') {
          formatted.total = source[i];
        } else {
          if (type === 'total') {
            let pipName = `${this.mediaMap[i]}：${source[i].ratio *
              100}%，¥${accounting.formatNumber(source[i].num, 2)}`;
            formatted.data.push({ name: pipName, value: source[i].num });
            formatted.legendData.push(pipName);
          } else {
            let pipName = `${this.posMap[i]}：${source[i].ratio *
              100}%，¥${accounting.formatNumber(source[i].num, 2)}`;
            formatted.data.push({ name: pipName, value: source[i].num });
            formatted.legendData.push(pipName);
          }
        }
      }
      return formatted;
    },

    // 1 米读  2 段子  3 趣键盘  4 趣头条  5 通投  6 联盟头部  7 联盟长尾
    regroupPileBarData(data) {
      if (!data.chartDate) {
        this.resetSlice();
        return;
      }
      // 广告位数据
      let chartDate = data.chartDate;

      this.slice1 = this.getSliceData('total', this.timeDuration, chartDate);
      this.slice2 = this.getSliceData('4', this.timeDuration, chartDate);
      this.slice3 = this.getSliceData('6', this.timeDuration, chartDate);
      this.slice4 = this.getSliceData('1', this.timeDuration, chartDate);
      this.slice5 = this.getSliceData('2', this.timeDuration, chartDate);
      this.slice6 = this.getSliceData('3', this.timeDuration, chartDate);
      this.slice7 = this.getSliceData('7', this.timeDuration, chartDate);
      this.slice8 = this.getSliceData('5', this.timeDuration, chartDate);
    },

    resetSlice() {
      this.slice1 = [];
      this.slice2 = [];
      this.slice3 = [];
      this.slice4 = [];
      this.slice5 = [];
      this.slice6 = [];
      this.slice7 = [];
      this.slice8 = [];
    },

    getSliceData(sliceType, timeDuration, charData) {
      let sliceData = timeDuration.map((item) => {
        let ret;
        // 如果当前日期有数据
        if (charData[item] && charData[item][sliceType]) {
          ret = charData[item][sliceType];
        } else {
          // 当前日期无数据，赋值{}
          ret = {};
        }
        return ret;
      });
      return this.formatChartData(sliceData, sliceType);
    },

    formatChartData(sliceData, sliceType) {
      let mediaOrSlot = sliceType === 'total' ? this.media : this.posSlot;
      // （纵坐标）媒体或者广告位的遍历
      return mediaOrSlot.map((item) => {
        let ret = [];
        // （横坐标）日期的遍历
        for (let i = 0; i < sliceData.length; i++) {
          if (Object.keys(sliceData[i]).length === 0) {
            // 当前横坐标是个空对象{}
            ret.push(null);
          } else {
            // 当前横坐标不是空对象
            if (sliceData[i][item]) {
              // 当前横坐标上的纵坐标有数据
              ret.push(sliceData[i][item]);
            } else {
              // 当前横坐标上的纵坐标无数据
              ret.push(null);
            }
          }
        }
        let itemName =
          sliceType === 'total' ? this.mediaMap[item] : this.posMap[item];
        return { name: itemName, data: ret };
      });
    },

    // resize
    onPieReize() {
      this.pieCharts && this.pieCharts.resize();
      this.pileBarCharts && this.pileBarCharts.resize();
    },
  },
};
</script>

<style lang="less" scoped>
.section-report {
  &.media {
    /deep/ .el-radio-button__inner {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(96, 98, 102, 1);
      padding: 8px 16px;
    }
    /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #2f9eff;
      background-color: #ffffff;
    }
  }
}
</style>
